import { UseQueryOptions } from '@tanstack/react-query';

import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';

const useContactDomains = (reactQueryOptions?: UseQueryOptions<any, Error>) => {
    const path = CuredApiPaths.REPORT_CONTACTS_DOMAINS;

    return useQuery('contacts-domains', path, reactQueryOptions);
};

export default useContactDomains;
